import { EnumValues } from './EnumValues';

export const BusinessRoleEnum = {
  DIRECTOR: 'director',
  SHAREHOLDER: 'shareholder',
  DIRECTOR_SHAREHOLDER: 'director_shareholder',
  EMPLOYEE: 'employee',
  OFFICER: 'officer'
} as const;

export const BusinessAccessLevelEnum = {
  OWNER: 'owner',
  ADMIN: 'admin',
  TEAM_MEMBER: 'team_member',
  NONE: 'none'
} as const;

export type TBusinessDetails = {
  businessId: string;
  businessName: string;
  businessDisplayName: string | null;
  role: EnumValues<typeof BusinessRoleEnum>;
  accessLevel: EnumValues<typeof BusinessAccessLevelEnum>;
};

export const AccountStatusEnum = {
  ACTIVE: 'active',
  PENDING_RFI: 'pending_rfi',
  PAUSED: 'paused',
  INACTIVE: 'inactive'
} as const;

export type TGetAccountResponse = {
  id: string;
  created: string;
  email: string | null;
  emailConfirmed: boolean | null;
  status: EnumValues<typeof AccountStatusEnum>;
  business?: TBusinessDetails;
};

export type TAccountPicture = {
  id: string;
  url: string;
};

export type TAccount = {
  accountDetails: TGetAccountResponse;
  name: string;
  picture: TAccountPicture | null;
  type: string;
};

// GET api/v1/accounts/{accountId}/tax-information
export type TRsAccountTaxInformation = {
  accountId: string;
  // Already hyphen-formatted by the backend (its own formatIRD, e.g. "123-456-789"), not the
  // raw-digits form this app's IRD number field state uses - run it through
  // extractIrdNumberDigits before storing/displaying it.
  irdNumber: string | null;
};
